import React from 'react';
import PropTypes from 'prop-types';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import RadarListCreate from 'components/Radar/Create';

const ScreenRadarCreate = ({ routePaths, target }) => {
  const initialFilters = useQueryString();
  return (
    <GridContainer justify="center">
      <GridItem xs={12} sm={6}>
        <RadarListCreate
          initialFilters={initialFilters}
          routePaths={routePaths}
          target={target}
        />
      </GridItem>
    </GridContainer>
  );
};

ScreenRadarCreate.propTypes = {
  routePaths: PropTypes.shape({}),
  target: PropTypes.string,
};

ScreenRadarCreate.defaultProps = {
  routePaths: undefined,
  target: undefined,
};

export default ScreenRadarCreate;
